import exerciseCardWhiteStyles from './exercise-card-white.module.less'
import exerciseCardDarkStyles from './exercise-card-dark.module.less'

import {
  Image,
  message,
  Button,
  Col,
  ConfigProvider,
  Row,
  Tabs,
  Table,
  Empty,
} from 'antd'

import {
  UpOutlined,
  DownOutlined,
} from '@ant-design/icons'
import React, { useEffect, useRef, useState } from 'react'
import zhCN from 'antd/lib/locale/zh_CN'
import Cookies from 'js-cookie'
import gfm from 'remark-gfm'
import remarkMath from 'remark-math'

import idataCourseTableDarkStyles from '../common/global-styles/idatacourse-table-dark.module.less'
import idataCourseTableWhiteStyles from '../common/global-styles/idatacourse-table.module.less'

import * as constants from '../../constants/constants'

import ReactMarkdown from 'react-markdown'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you

import rehypeRaw from 'rehype-raw'

import MonacoEditor from 'react-monaco-editor'
// import CodeMirror from 'react-codemirror2';
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/material-darker.css' // dark 模式
import 'codemirror/theme/xq-light.css' // light 模式

import 'codemirror/mode/python/python' // 代码提示
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/show-hint'

// import 'codemirror/addon/hint/python-hint';
import 'codemirror/addon/selection/active-line' // 选中行高亮
import 'codemirror/addon/selection/selection-pointer'
import 'codemirror/addon/selection/mark-selection'
import 'codemirror/addon/search/matchesonscrollbar.css'
import 'codemirror/addon/search/searchcursor'
import 'codemirror/addon/search/match-highlighter'

import 'codemirror/addon/comment/comment' // 支持ctrl(cmd) + / 快速(取消)注释
import 'codemirror/keymap/sublime' // sublime关键字

import 'codemirror/addon/edit/closebrackets' // 封闭括号
import 'codemirror/addon/edit/matchbrackets' // 匹配括号


import './exercise.css'
import clean1 from '../../static/image/exercise/clean1.png'
import exerciseStyles from '@/pages/exercise/exercise.module.less'

import rehypeHighlight from 'rehype-highlight'
import { sendHttpPostRequest } from '../../api/http-request'
const { TabPane } = Tabs

export interface Props {
  exercise: any
  renderType: string //渲染的主题类型，"dark","white"
  teacherOnly: boolean // 仅老师
  editorMode: boolean //是否可编辑模式，
  showAnser: boolean //是否默认显示答案
  showClean: boolean //是否显示清除按钮
}

/* 数据实操题 */
export const ExerciseCardDataCoding: React.FC<Props> = (props) => {
  const {
    exercise,
    renderType,
    editorMode,
    showAnser,
    showClean,
  } = props
  // console.log(parseInt(exercise?.submission_info?.submission_id), exercise?.submission_info?.submission_code, exercise?.default_code);

  /** 调试切换相同题目  代码区默认展示内容 **/
  // const [userCode, setUserCode] = useState("");
  // const [userCode, setUserCode] = useState(parseInt(exercise?.submission_info?.submission_id) > 0 ? exercise?.submission_info?.submission_code : exercise?.default_code);
  const userCode = useRef(
    parseInt(exercise?.submission_info?.submission_id) > 0
      ? exercise?.submission_info?.submission_code
      : exercise?.default_code
  )
  // const userCode = useRef('');   // 调试切换相同题目 代码区默认展示内容
  const cachedExerciseId = useRef(exercise?.id)

  const [answervisible, setAnswerVisible] = useState(showAnser) //参考答案是否可见
  // const [cleanVisible, setCleanVisible] = useState(showClean)//清除按钮是否可见

  const [running, setRunning] = useState(false) // 运行中状态

  const [currentStatus, setCurrentStatus] = useState(null as any)

  const [outputs, setOutputs] = useState(null as any) //运行的输出结果
  const [isHtml, setIsHtml] = useState(false)
  const [variables, setVariables] = useState(null as any) //运行的输出变量列表
  const [figures, setFigures] = useState(null as any) // 运行输出的图
  const [activeKey, setActiveKey] = useState('') // 默认激活的tab页

  const exerciseCardStyles =
    renderType == 'white' ? exerciseCardWhiteStyles : exerciseCardDarkStyles
  const [isReload, setIsReload] = useState(false) // 每次点击重新渲染
  const [values, setValues] = useState(
    userCode.current && cachedExerciseId.current == exercise?.id
      ? userCode.current
      : parseInt(exercise?.submission_info?.submission_id) > 0
      ? exercise?.submission_info?.submission_code
      : exercise?.default_code
  )

  const editorOptions = {
    selectOnLineNumbers: true,
    fontSize: 14,
    minimap: { enabled: false },
    lineDecorationsWidth: 5,
    lineNumbersMinChars: 2,
    quickSuggestions: false,
    // scrollBeyondLastLine: false,  // 控制是否可以滚动到最后一行下面
    // scrollbar: {
    //     verticalScrollbarSize: 0,  // 垂直滚动条宽度
    //     horizontalScrollbarSize: 0,  // 水平滚动条宽度
    // },
    automaticLayout: true, // 拖拽分屏线时自适应宽度
  }

  const editorReadOnlyoptions = {
    readOnly: true,
    selectOnLineNumbers: true,
    fontSize: 14,
    minimap: { enabled: false },
    lineDecorationsWidth: 5,
    lineNumbersMinChars: 2,
    quickSuggestions: false,
    // scrollBeyondLastLine: false,  // 控制是否可以滚动到最后一行下面
    // scrollbar: {
    //     verticalScrollbarSize: 0,  // 垂直滚动条宽度
    //     horizontalScrollbarSize: 0,  // 水平滚动条宽度
    // },
    automaticLayout: true, // 拖拽分屏线时自适应宽度
  }

  const columns: any = [
    {
      title: '变量',
      dataIndex: 'var',
      key: 'var',
      align: 'left',
      width: 60,
      ellipsis:true,
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      align: 'left',
      width: 60,
      ellipsis:true,
    },

    {
      title: '取值',
      dataIndex: 'value',
      key: 'value',
      align: 'left',
      width: 100,
      ellipsis:true,
      render: (text: any) => text
        //text?.length > 50 ? text.slice(0, 50) : text,
    },
  ]
  useEffect(() => {
    if (cachedExerciseId.current != exercise?.id) {
      userCode.current = ''
      exercise.reference_answer = ''
      setValues('')
    }
    if (exercise?.submission_info && exercise?.submission_info?.submission_status){
      // 初始化运行结果
      if (exercise?.submission_info?.submission_status == 2) {
        if (exercise?.submission_info.is_html) {
          setOutputs(exercise?.submission_info.output)
          setIsHtml(true)
          setFigures('')
          const chartId = exercise?.submission_info.js_script.substr(
            exercise?.submission_info.js_script.indexOf("document.getElementById('") + 25,
            32
          )
          //console.log(chartId)
          let checkResult = setInterval(function () {
            // console.log(document.getElementById(chartId))
            if (document.getElementById(chartId) != null) {
              try {
                setTimeout(function () {
                  eval(exercise?.submission_info.js_script)
                }, 1000)
                clearInterval(checkResult)
              } catch (e) {
                console.error(e)
                clearInterval(checkResult)
                try {
                  setTimeout(function () {
                    eval(exercise?.submission_info.js_script)
                  }, 1000)
                } catch (e) {
                  console.error(e)
                }
              }
            }
          }, 1500)
        } else {
          //message.success(`回答正确${response.data.output}`);
          let output = exercise?.submission_info.submission_output.trim() //.replaceAll('\n', '<br/>'
          setOutputs(output)
          setFigures(exercise?.submission_info.submission_image)
        }
        setVariables(exercise?.submission_info.submission_variables)
        setCurrentStatus(true)
        exercise?.submission_info.submission_image.length > 0 || exercise?.submission_info.is_html
          ? setActiveKey('figures')
          : setActiveKey('outputs')
      } else if(exercise?.submission_info?.submission_status == 3) {
        setOutputs(exercise?.submission_info.submission_output)
        setVariables(exercise?.submission_info.submission_variables)
        setCurrentStatus(false)
        setFigures(exercise?.submission_info.submission_image)
        exercise?.submission_info.submission_image.length > 0
          ? setActiveKey('figures')
          : setActiveKey('outputs')
      }
  }
    
  }, [])

  const runCodeCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
      // window.location.href = `/oam_login?next=oam_preview_exercise?exercise_id=${exercise.id}`;
    } else if (response.code == 0) {
      // 成功
      // TODO: 答题卡片渲染执行结果，不在这里弹提示
      // TODO: 填空题有的输出图片，需要在卡片渲染出来
      if (response.data.status == true) {
        if (response.data.is_html) {
          setOutputs(response.data.output)
          setIsHtml(true)
          setFigures('')
          const chartId = response.data.js_script.substr(
            response.data.js_script.indexOf("document.getElementById('") + 25,
            32
          )
          console.log(chartId)
          let checkResult = setInterval(function () {
            // console.log(document.getElementById(chartId))
            if (document.getElementById(chartId) != null) {
              try {
                setTimeout(function () {
                  eval(response.data.js_script)
                }, 1000)
                clearInterval(checkResult)
              } catch (e) {
                console.error(e)
                clearInterval(checkResult)
                try {
                  setTimeout(function () {
                    eval(response.data.js_script)
                  }, 1000)
                } catch (e) {
                  console.error(e)
                }
              }
            }
          }, 1500)
        } else {
          //message.success(`回答正确${response.data.output}`);
          let output = response.data.output.trim()//Left().replaceAll('\n', '<br/>')
          setOutputs(output)
          setFigures(response.data.images)
        }
        setVariables(response.data.variables)
        setCurrentStatus(true)
        response.data.images.length > 0 || response.data.is_html
          ? setActiveKey('figures')
          : setActiveKey('outputs')
      } else {
        setOutputs(response.data.output)
        setVariables(response.data.variables)
        setCurrentStatus(false)
        setFigures(response.data.images)
        response.data.images.length > 0
          ? setActiveKey('figures')
          : setActiveKey('outputs')
      }
    } else if (response.code == -501) {
      // 权限不足
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
      // window.location.href = `/oam_login?next=oam_preview_exercise?exercise_id=${exercise.id}`;
    } else {
      message.error(response.message)
    }
    setRunning(false)
  }
  const [values2, setValues2] = useState('') // 用来保存提交的值

  //点击了提交按钮
  const exerciseSubmitBtnClick = () => {
    setValues2(values)
    if (userCode.current == '') {
      userCode.current =
        parseInt(exercise?.submission_info?.submission_id) > 0
          ? exercise?.submission_info?.submission_code
          : exercise?.default_code
    }
    let _params = {
      sessionid: Cookies.get('sessionid'),
      exercise_id: exercise.id,
      code: userCode.current,
      source_page: exercise.source_page,
      source_key: exercise.source_key,
      course_id: exercise.course_id,
      chapter_id: exercise.chapter_id,
      knowcell_id: exercise.knowcell_id,
    }
    if ([3, 4].includes(exercise.source_page)) {
      // 作业、考试
      //if (userCode.current != '' && userCode.current != exercise.default_code) {
        setCurrentStatus(null as any)
        setRunning(true)

        if (exercise.exam_id) {
          _params['exam_id'] = exercise.exam_id // 考试传考试id
        } else if (exercise.homework_id) {
          _params['homework_id'] = exercise.homework_id // 作业传作业id
        }
        sendHttpPostRequest(
          'exercise/api/exercise_run/',
          _params,
          runCodeCallback
        )
      //} //else {
        // console.log("实操题没输入答案")
      //}
    } else {
      setCurrentStatus(null as any)
      setRunning(true)

      sendHttpPostRequest(
        'exercise/api/exercise_run/',
        _params,
        runCodeCallback
      )
    }
    //}
  }

  // 看答案回调
  const queryExerciseAnswerCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      // 成功
      if (response.exercise_answer) {
        exercise.reference_answer = response.exercise_answer.reference_answer
        setAnswerVisible(true)
      }
    } else if (response.code == -501) {
      // 权限不足
      // document.getElementById("show-login-modal")!.click();
    } else {
      message.error(response.message)
    }
  }

  //点击了参考答案按钮
  const exerciseAnswerBtnClick = () => {
    if (exercise.reference_answer.length == 0) {
      // 查询答案
      // if (0 == exercise.reference_answer.length) {
      sendHttpPostRequest(
        'exercise/api/query_exercise_answer/',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
          exercise_id: exercise.id,
        },
        queryExerciseAnswerCallback
      )
      // }
    } else {
      setAnswerVisible(!answervisible)
    }
  }

  // 渲染 查看答案按钮
  const renderAnswerButton = () => {
    if (!answervisible) {
      if (exercise.reference_answer.length == 0) {
        if (![3, 4].includes(exercise.source_page)) {
          return (
            <Button
              onClick={(e) => {
                e.stopPropagation()
                exerciseAnswerBtnClick()
              }}
              type="link"
              style={{ width: 80, marginRight: 10, borderRadius: 20 }}
            >
              <span>参考代码</span>
              <DownOutlined />{' '}
            </Button>
          )
        }
      } else {
        if (![3, 4].includes(exercise.source_page)) {
          return (
            <Button
              onClick={exerciseAnswerBtnClick}
              type="link"
              style={{ width: 80, marginRight: 10, borderRadius: 20 }}
            >
              {' '}
              <span>参考代码</span>
              <DownOutlined />
            </Button>
          )
        }
      }
    } else {
      if (![3, 4].includes(exercise.source_page)) {
        return (
          <Button
            onClick={exerciseAnswerBtnClick}
            type="link"
            style={{ width: 80, marginRight: 10, borderRadius: 20 }}
          >
            <span>折叠收起</span>
            {!answervisible ? <DownOutlined /> : <UpOutlined />}
          </Button>
        )
      }
    }
  }

  //监听窗口事件
  useEffect(() => {
    const listener = (ev) => {
      if (userCode.current != values) {
        ev.returnValue = false
      }
    }
    window.addEventListener('beforeunload', listener)

    return () => {
      window.removeEventListener('beforeunload', listener)
    }
  }, [values2]) // 当values2的值改变时,重新进行监听

  const cleanAll = () => {
    message.destroy()
    userCode.current = exercise?.default_code
    setValues(exercise?.default_code)
    setIsReload(!isReload)
    message.success('清空成功')
  }

  //用户编辑代码发生改变


  const getRunnigStatusBtn = () => {
    return (
      <Button
        disabled={running}
        hidden={exercise?.hint_submit_btn == 2}
        id={'exercise-run-' + exercise.id}
        onClick={exerciseSubmitBtnClick}
        type="primary"
        style={{ borderRadius: 20, width: 80, textShadow:'none', boxShadow:'none'}}
        className="exercise-run-button"
      >
        {[3, 4].includes(exercise.source_page) ? ' 提 交 ' : ' 测 试 '}
      </Button>
    )
    // }
  }

  // 追加页面上输入的词到代码提示

  /** 渲染查看变量取值的习题 */
  const renderVariablePreview = (record: any) => {
    return <div>{record.value}</div>
  }

  return (
    <div
      style={{ marginBottom: 20, textAlign: 'left' }}
      className={exerciseCardStyles.wrapper}
    >
      {/*<div style={{ marginBottom: 10, fontSize: 14 }}>{'【实操】'}</div>*/}

      <div>
        <ReactMarkdown
          className={exerciseCardStyles.reactmarkdownTitle}
          remarkPlugins={[gfm, remarkMath]}
          rehypePlugins={[rehypeHighlight, rehypeKatex]}
        >
          {exercise.steps}
        </ReactMarkdown>

        <div
          className={exerciseCardDarkStyles.imgContainer}
          style={{ marginTop: 10, marginBottom: 10 }}
        >
          <ConfigProvider locale={zhCN}>
            <Row justify="center" align="middle" gutter={[10, 10]}>
              {exercise?.images?.map((image: any) => {
                return (
                  <Col key={image.name}>
                    <Image
                      style={{maxWidth:'100%'}}
                      preview={false}
                      src={constants.BACKEND_URL + image.path + image.name}
                    />
                  </Col>
                )
              })}
            </Row>
          </ConfigProvider>
        </div>
      </div>

      <div style={{ textAlign: 'right', marginBottom: 0 }}>
        {renderAnswerButton()}
      </div>
      <Row align="top" gutter={[8, 8]}>
        <Col span={answervisible == true ? 12 : 24}>
          <div
            className={exerciseCardStyles.userCode}
            style={{ height: 400, marginBottom: 10 }}
          >

            <div
              style={{ textAlign: 'left' }}
              className={renderType == "dark" ? "" :'oam-exercise-code-editor'}
            >
              <MonacoEditor
                className={exerciseStyles.codeEditor}
                height="400px"
                width="100%"
                language={'python'}
                theme={renderType == 'white' ? 'vs' : 'vs-dark'} //"vs" | "vs-dark" | "hc-black"
                value={userCode.current}
                options={ editorMode == true?editorOptions:editorReadOnlyoptions}
                onChange={(value) => {
                  // console.log('controlled', value);
                  userCode.current = value != '' ? value : ' '
                  // console.log(cachedExerciseId.current, exercise?.id);
                  if (cachedExerciseId.current != exercise?.id)
                    cachedExerciseId.current = exercise?.id
                  // onUserCodeChange.bind(this, value);
                }}
                //editorDidMount={editorDidMount}
              />
            </div>
          </div>
        </Col>

        {answervisible == true && (
          <Col span={12}>
            <div
              className={exerciseCardStyles.userCode}
              style={{ height: 400, marginBottom: 10 }}
            >

              <div
                style={{ textAlign: 'left' }}
                className={renderType == "dark" ? "" :'oam-exercise-code-editor'}
              >
                <MonacoEditor
                  className={exerciseStyles.codeEditor}
                  height="400px"
                  width="100%"
                  language={'python'}
                  theme={renderType == 'white' ? 'vs' : 'vs-dark'} //"vs" | "vs-dark" | "hc-black"
                  value={exercise.reference_answer}
                  // options={editorOptions}
                  options={editorReadOnlyoptions}
                  // onChange={onUserCodeChange}
                  //editorDidMount={editorDidMount}
                />
              </div>
            </div>
          </Col>
        )}
      </Row>

      <Row
        justify="start"
        align="middle"
        gutter={[8, 8]}
        style={{margin:'0 0 10px 0' }}
      >
        <Col flex={'auto'} style={{paddingLeft:0, paddingRight:0}}>
          {showClean ? (
            <div
              className={exerciseCardStyles.imageHover}
              style={{ marginLeft: 0, width: 18, height: 18 }}
            >
              <Image
                alt=""
                src={clean1}
                className={exerciseCardStyles.codeClean}
                preview={false}
                onClick={cleanAll}
              />
            </div>
          ) : (
            ''
          )}
        </Col>
        <Col flex={'75px'} style={{ textAlign: 'right', paddingLeft:0, paddingRight:0}}>
          {getRunnigStatusBtn()}
        </Col>
      </Row>
      {/* {(currentStatus == true || currentStatus == false) && ( */}
      <div className={exerciseCardStyles.resultCardContainer}>
        <Row
          className={exerciseCardStyles.resultCardHeader}
          align={'middle'}
          justify={'start'}
        >
          {' '}
          <Col className={exerciseCardStyles.titleText}>测试结果</Col>
          <Col>
            {running ? (
              <span
                className="iconfont icon_zhengzaitingzhi"
                style={{ fontSize: '20px', color: '#4285F4' }}
              ></span>
            ) : currentStatus == true ? (
              <span
                className="iconfont icon_goujianchenggong"
                style={{ fontSize: '20px', color: '#07C160' }}
              ></span>
            ) : currentStatus == false ? (
              <span
                className="iconfont icon_tingzhi-20"
                style={{ fontSize: '20px', color: '#FF4B50' }}
              ></span>
            ) : (
              ''
            )}
          </Col>
        </Row>
        <Tabs defaultActiveKey={activeKey}>
          <TabPane tab="运行结果" key="outputs">
            <div style={{ marginBottom: 10, paddingTop: 0, borderRadius: 5,maxHeight:600, overflow:'auto' }}>
              {outputs ? (
                <ReactMarkdown
                  className={exerciseCardStyles.reactmarkdownRunResult}
                  remarkPlugins={[gfm, remarkMath]}
                  rehypePlugins={[rehypeKatex, rehypeRaw]}
                >
                  { exercise?.submission_info?.submission_output?.is_html?  outputs: outputs.replaceAll(">","&gt;").replaceAll("<","&lt;").replaceAll("\n","<br/>")}
                  
                </ReactMarkdown>
              ) : (
                <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    <span className={exerciseCardStyles.emptyText}>
                      {'暂无运行结果'}
                    </span>
                  }
                />
              )}
            </div>
          </TabPane>
          <TabPane tab="变量信息" key="variables">
            <div style={{ marginBottom: 10, paddingTop: 0, borderRadius: 5 }}>
              <div
                className={
                  renderType == 'dark'
                    ? idataCourseTableDarkStyles.tableWrapper
                    : idataCourseTableWhiteStyles.tableWrapper
                }
              >
                <ConfigProvider locale={zhCN}>
                  <Table
                    dataSource={variables}
                    columns={columns}
                    rowKey={(record) => record.var}
                    pagination={false}
                    //scroll={{ x: 800 }}
                  />
                </ConfigProvider>
              </div>
            </div>
          </TabPane>

          <TabPane tab="图像输出" key="figures">
            <div style={{ marginBottom: 10, paddingTop: 0, borderRadius: 5 }}>
              {figures?.length > 0 ? (
                <div
                  style={{textAlign:'center'}}
                  className={
                    renderType == 'dark'
                      ? idataCourseTableDarkStyles.tableWrapper
                      : idataCourseTableWhiteStyles.tableWrapper
                  }
                >
                  {figures?.map((figure, index) => {
                    return (
                      <img
                        style={
                          renderType == 'dark'
                            ? { maxWidth: '100%', background: '#f9f9f9' }
                            : { maxWidth: '100%' }
                        }
                        key={index}
                        src={'data:image/jpg;base64,' + figure}
                      />
                    )
                  })}
                </div>
              ) : (
                <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    <span className={exerciseCardStyles.emptyText}>
                      {'暂无运行结果'}
                    </span>
                  }
                />
              )}
            </div>
          </TabPane>
        </Tabs>
      </div>
      {/* )} */}
    </div>
  )
}

export default ExerciseCardDataCoding
